import { Component, Input } from '@angular/core';
import { Topics } from '@models/entities/subscription';

@Component({
    selector: 'app-card-plan',
    templateUrl: './card-plan.component.html',
    styleUrls: ['./card-plan.component.scss'],
    standalone: false
})
export class CardPlanComponent {
  @Input() detail: boolean;
  @Input() info: Topics;
  @Input() isSpecial: boolean | undefined;
}
